<template>
  <div>
    <h1 class="page-header">{{ $t('room.pageTitle') }}</h1>
    <div class="row">
      <div class="col-md-12">
        <ts-card>
          <ts-card-wrapper>
            <form class="form-horizontal">
              <div class="row mb-3">
                <div class="col-sm-12 col-lg-4 col-md-12">
                  <div class="form-group row">
                    <label
                      class="col-md-4 form-col-label control-label text-right required"
                    >
                      {{ $t('room.name') }}
                    </label>
                    <div class="col-md-8">
                      <input
                        ref="room_name"
                        type="text"
                        v-model="model.room_name"
                        class="form-control"
                        :class="{ 'is-invalid': errors.has('room_name') }"
                        :placeholder="$t('room.enterroomname')"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="errors.has('room_name')"
                      >
                        {{ errors.first('room_name') }}
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label
                      class="col-md-4 form-col-label control-label text-right required"
                    >
                      {{ $t('room.roomTypee') }}
                    </label>
                    <div class="col-md-8">
                      <select
                        v-model.number="model.room_type_id"
                        class="form-control"
                        :class="{ 'is-invalid': errors.has('room_type_id') }"
                      >
                        <option
                          value=""
                          disabled
                          selected
                          style="display: none;"
                        >
                          {{ $t('select') }}</option
                        >
                        <option
                          v-for="(room_type, index) in room_types"
                          :key="index"
                          :value="room_type.room_type_id"
                        >
                          {{ room_type.room_type }}
                        </option>
                      </select>
                      <div
                        class="invalid-feedback"
                        v-if="errors.has('room_type_id')"
                      >
                        {{ errors.first('room_type_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label
                      class="col-md-4 form-col-label control-label text-right required"
                    >
                      {{ $t('room.floor') }}
                    </label>
                    <div class="col-md-8">
                      <input
                        type="text"
                        v-model="model.floor_no"
                        class="form-control"
                        :class="{ 'is-invalid': errors.has('floor_no') }"
                        :placeholder="$t('room.enterroomfloor')"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="errors.has('floor_no')"
                      >
                        {{ errors.first('floor_no') }}
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label
                      class="col-md-4 form-col-label control-label text-right required"
                    >
                      {{ $t('room.building') }}
                    </label>
                    <div class="col-md-8">
                      <select
                        v-model.number="model.building_id"
                        class="form-control"
                        :class="{ 'is-invalid': errors.has('building_id') }"
                      >
                        <option
                          value=""
                          disabled
                          selected
                          style="display: none;"
                        >
                          {{ $t('select') }}</option
                        >
                        <option
                          v-for="(building, index) in buildings"
                          :key="index"
                          :value="building.building_id"
                        >
                          {{ building.building_name }}
                        </option>
                      </select>
                      <div
                        class="invalid-feedback"
                        v-if="errors.has('building_id')"
                      >
                        {{ errors.first('building_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label
                      class="col-md-4 form-col-label control-label text-right"
                    >
                      {{ $t('room.description') }}
                    </label>
                    <div class="col-md-8">
                      <textarea
                        class="form-control"
                        rows="4"
                        :placeholder="$t('room.enterroomdescription')"
                        v-model="model.room_desc"
                      >
                      </textarea>
                      <div
                        class="invalid-feedback"
                        v-if="errors.has('room_desc')"
                      >
                        {{ errors.first('room_desc') }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 col-lg-8 col-md-12">
                  <div class="form-group row">
                    <label
                      class="col-md-3 form-col-label control-label text-right required"
                    >
                      {{ $t('room.capacity') }}
                    </label>
                    <div class="col-md-7">
                      <div class="d-flex">
                        <input
                          type="number"
                          v-model.number="model.capacity"
                          min="0"
                          class="form-control"
                          :class="{ 'is-invalid': errors.has('capacity') }"
                          :placeholder="$t('room.enterroomcapacity')"
                        />
                        <label
                          class="col-md-3 form-col-label control-label text-right"
                        >
                          {{ $t('room.lengthm') }}
                        </label>
                        <input
                          type="number"
                          min="0"
                          v-model="model.length"
                          @input="onLength"
                          class="form-control"
                          :class="{ 'is-invalid': errors.has('length') }"
                          :placeholder="$t('room.enterroomlength')"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label
                      class="col-md-3 form-col-label control-label text-right"
                    >
                      {{ $t('room.widthm') }}
                    </label>
                    <div class="col-md-7">
                      <div class="d-flex">
                        <input
                          type="number"
                          min="0"
                          v-model="model.width"
                          @input="onWidth"
                          class="form-control"
                          :class="{ 'is-invalid': errors.has('width') }"
                          :placeholder="$t('room.enterroomwidth')"
                        />
                        <label
                          class="col-md-3 form-col-label control-label text-right"
                        >
                          {{ $t('room.heightm') }}
                        </label>
                        <input
                          type="number"
                          min="0"
                          v-model="model.height"
                          @input="onHeight"
                          class="form-control"
                          :class="{ 'is-invalid': errors.has('height') }"
                          :placeholder="$t('room.enterroomheight')"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label
                      class="col-md-3 form-col-label control-label text-right"
                    >
                      {{ $t('room.totalSquare') }} (m<sup>2</sup>)
                    </label>
                    <div class="col-md-7">
                      <div class="d-flex">
                        <input
                          type="text"
                          readonly
                          v-model="model.total_square"
                          class="form-control"
                          :class="{ 'is-invalid': errors.has('total_square') }"
                          :placeholder="$t('room.roomtotalsquare')"
                        />
                        <label
                          class="col-md-3 form-col-label control-label text-right"
                        >
                          {{ $t('room.dimension') }} (m<sup>3</sup>)
                        </label>
                        <input
                          type="text"
                          readonly
                          v-model="model.dimension"
                          class="form-control"
                          :class="{ 'is-invalid': errors.has('dimension') }"
                          :placeholder="$t('room.roomDimension')"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <div class="row">
                <div class="col-sm-12 col-lg-12 col-md-12 text-right">
                  <ts-button
                    color="primary"
                    :waiting="waiting"
                    @click.prevent="update"
                  >
                    {{ $t('update') }}
                  </ts-button>
                  <ts-button
                    class="ml-2"
                    @click.prevent="$router.push({ name: 'room' })"
                    >{{ $t('cancel') }}</ts-button
                  >
                </div>
              </div>
            </form>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
export default {
  name: 'room-edit',
  data() {
    return {
      model: _.cloneDeep(),
      errors: new Errors(),
      waiting: false
    }
  },
  mounted() {
    this.$refs.room_name.focus()
  },
  created() {
    this.setEditData()
  },
  computed: {
    ...mapState('room', ['found_data', 'buildings', 'room_types'])
  },
  methods: {
    onLength() {
      if (this.model.length == '') {
        this.model.total_square = 0
        this.model.dimension = 0
        return
      }
      this.calulate()
    },

    onWidth() {
      if (this.model.width == '') {
        this.model.total_square = 0
        this.model.dimension = 0
        return
      }
      this.calulate()
    },

    onHeight() {
      if (this.model.height == '') {
        this.model.dimension = 0
        return
      }
      this.calulate()
    },

    calulate() {
      this.model.total_square = this.model.length * this.model.width
      this.model.dimension =
        this.model.length * this.model.width * this.model.height
    },

    async update() {
      this.errors = new Errors()
      this.waiting = true

      this.$store
        .dispatch('room/update', this.model)
        .then(response => {
          this.waiting = false
          this.$toasted.success(response.message)
          this.$router.push({ name: 'room' })
        })
        .catch(error => {
          this.waiting = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    },

    setEditData() {
      if (this.found_data === null) return

      this.model = Object.assign({}, this.found_data)
    }
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('room/RESET_STATE')
      this.$store.commit('room/SET_FOUND_DATA', {})
      this.$store.commit('room/SET_BUILDINGS', [])
      this.$store.commit('room/SET_ROOM_TYPES', [])
    }
    next()
  }
}
</script>
